import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { styles } from './ReportWidget.styles';

export interface ReportWidgetProps {
  children: ReactNode;
  onClick: () => void;
  active?: boolean;
}

export const ReportWidget: React.FC<ReportWidgetProps> = ({ active, children, onClick }) => {
  return active === false ? (
    <Box sx={styles.box}>{children}</Box>
  ) : (
    <Box onClick={onClick} sx={styles.clickableBox}>
      {children}
    </Box>
  );
};
